import { Pipe, PipeTransform, inject } from '@angular/core';
import {
  FormatCo2eOptions,
  FormatCo2eService,
} from '../shared/services/format-co2e.service';

@Pipe({
  name: 'formatCO2e',
  standalone: true,
})
export class FormatCO2ePipe implements PipeTransform {
  private formatService = inject(FormatCo2eService);

  transform(value: number, options?: FormatCo2eOptions): string {
    return this.formatService.format(value, options);
  }
}
